import { Component, OnDestroy, OnInit } from '@angular/core';
import { IPaymentInfo } from '../../../interfaces/IJob';
import { DataService } from '../../../services/data/data.service';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { ACH_AUTO, CARD_TYPES, PAYMENTECH } from '../../../utils/constants';
import { Subject, combineLatest, takeUntil } from 'rxjs';

@Component({
  selector: 'app-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrl: './payment-type.component.scss'
})
export class PaymentTypeComponent implements OnInit, OnDestroy {
  billingData: IPaymentInfo | null = null;
  cardTypes = CARD_TYPES;
  isGenericBilling: boolean = false;
  isPaymentech: boolean = false;
  isAchAuto: boolean = false;
  formattedCardNumber: string = '';
  formattedBankAccountNumber: string = '';
  cleaner$ = new Subject<void>();

constructor(private data: DataService, private utils: UtilitiesService) { }

  ngOnInit() {
    combineLatest({
      contract: this.data.contractData$,
      enrollmentPaymentInfo: this.data.enrollmentPaymentInfo$
    })
    .pipe(takeUntil(this.cleaner$))
    .subscribe({
      next: ({ contract, enrollmentPaymentInfo }) => {
        this.billingData = enrollmentPaymentInfo || contract?.paymentInfo || null;
        this.updateBillingFlags();
      }
    });
  }

  getCardTypeImage(typeCode: string): string {
     return (CARD_TYPES[typeCode ? typeCode.toLowerCase() : 'unknown']).src;
  }

  updateBillingFlags(): void {
    const billMechCode = this.billingData?.billMechCode;

    this.isGenericBilling = !!billMechCode && ![PAYMENTECH, ACH_AUTO].includes(billMechCode);
    this.isPaymentech = billMechCode === PAYMENTECH;
    this.isAchAuto = billMechCode === ACH_AUTO;
    this.formattedCardNumber = this.utils.updateMaskedCard(this.billingData?.creditCardNumber ?? '');

    const acct = this.billingData?.bankAcctNumber ?? '';
    this.formattedBankAccountNumber = this.maskBankAccount(acct);
  }

  private maskBankAccount(acct: string): string {
    if (!acct) return '';
    if (acct.startsWith('*') || acct.startsWith('X')) {
      return acct;
    }
    return `****${acct.slice(-4)}`;
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

}
